import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { ALLOW_ANONYMOUS, JWTTokenModel } from '@delon/auth';
import { DA_SERVICE_TOKEN } from '@delon/auth';

function newReq(
  req: HttpRequest<unknown>,
  model: JWTTokenModel
): HttpRequest<unknown> {
  return req.clone({
    setHeaders: {
      Authorization: `Bearer ${model.token}`
    }
  });
}

export function isAnonymousPage(url: string): boolean {
  const anonymousPages = ['/full/einvoice/', '/full/view/', '/full/portal/'];
  return anonymousPages.some(page => url.includes(page));
}

function isAnonymous(req: HttpRequest<unknown>): boolean {
  const anonymousPages = ['/full/einvoice/', '/full/view/', '/full/portal/'];

  const currentUrl = window.location.href;
  // If current url is anonymous page, return true
  if (anonymousPages.some(page => currentUrl.includes(page))) return true;

  // Determine if the request is anonymous
  return req.context.get(ALLOW_ANONYMOUS) === true;
}

export const customJwtInterceptor: HttpInterceptorFn = (req, next) => {
  // If the request is anonymous, proceed with the original request without modification
  if (isAnonymous(req)) return next(req);

  const model = inject(DA_SERVICE_TOKEN).get<JWTTokenModel>(JWTTokenModel);
  // If the token is valid, add it to the request
  if (CheckJwt(model)) return next(newReq(req, model));
  // If the token is invalid, proceed with the original request without modification
  else return next(req);
};

export function CheckJwt(model: JWTTokenModel): boolean {
  try {
    return model != null && !!model.token && !model.isExpired(10);
  } catch (err: unknown) {
    return false;
  }
}
